import {
  Routes, Route
} from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import IntractiveMap from './components/IntractiveMap';
import Bulletine from './components/Bulletine';
// import Spatial from './components/Spatial';
import Footer from './components/Footer';
import CropYield from './components/CropYield';
function App() {
  return (
    <>
    {/* To navigat between pages  */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cropYield" element={<CropYield />} />
        <Route path='/intractive' element={<IntractiveMap />} />
        <Route path='/Reports' element={<Bulletine />} />
        {/* <Route path='/spatial' element={<Spatial />} /> */}
      </Routes>
      <Footer/>
    </>
  );
}

export default App;
